import { AppThunk } from '../../../../store/types';
import { VocabularyComponentUtils } from '../../Vocabulary/vocabulary/utils/VocabularyComponentUtils';
import { PhraseListActions } from '../../../../store/phrase-list/actions';
import { getVideoTeacherUserActiveId } from '../../../../store/videos/selectors';
import { TeachersEffects } from '../../../../effects/teachersEffects';

export class PhraseListSelectVideoEvents {

	public static onChangeListMode(listModeId: string): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			const listMode = VocabularyComponentUtils.getListModeById(getState(), listModeId);
			if (listMode) {
				dispatch(PhraseListActions.setListMode(listMode.listMode, listMode.langCode));
			}

			const teacherActiveId = getVideoTeacherUserActiveId(getState());
			if (teacherActiveId) {
				TeachersEffects.hidePhrases();
			}
		}
	}

}